import { useMutation } from "react-query";
import updateKyc from "../services/updateKyc";

const useUpdateKyc = () => {
  return useMutation(["update-kyc"], updateKyc);
};

export default useUpdateKyc;
